<template>
  <v-row justify="center">
    <v-dialog max-width="600px" persistent v-model="$store.state.editUserModal">
      <v-card>
        <v-form ref="form" v-model="valid">
          <v-card-title>
            <span class="headline"> プロフィールの編集 </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-textarea label="プロフィール" :counter="100" :rules="userProfileRules" v-model="userProfile" />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click.stop="toggleEditUserModal()"> キャンセル </v-btn>
            <v-btn color="blue darken-1" :disabled="!valid" text @click="editUserProfile()"> 保存 </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["loginUserInfo"]),
  },
  created(){
    if(this.loginUserInfo) this.userProfile = this.loginUserInfo.userProfile
  },
  data: () => ({
    valid: true,
    userProfile: '',
    userProfileRules: [
      (v) => !!v || "プロフィール文は入力必須です！",
      (v) => (v && v.length <= 100) || "プロフィール文は100文字以内で入力してください！",
    ],
  }),
  methods: {
    ...mapActions(["toggleEditUserModal", "updateUserProfile"]),
    // プロフィール文を編集します.
    editUserProfile() {
      this.$refs.form.validate();
      this.updateUserProfile(this.userProfile);
      this.toggleEditUserModal();
    },
  },
};
</script>
